//todo: seperate toolbar from this file
import React, { Component } from "react";

import { sleep, lightenColor } from "utils/Utils";
import { observer } from "mobx-react";

import { CircularProgress, Fab, Grow } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import NavigationIcon from "@material-ui/icons/Navigation";

import Pages from "../../Pagination/Pages";

import { debounce, isEmpty } from "lodash";
import { DIMENSIONS } from "utils/Dimensions";
import COLORS from "scss/colors.module.scss";
import Moment from "moment";
import { getGridComponents } from "./helpers/getGridComponents";
import AddColumnPopup from "app/list/AddColumn/AddColumnPopup";
import TriggerColumnPopper from "./columnEditors/Triggers/TriggerColumnPopper";
import ErrorTooltip from "./columnEditors/ErrorTooltip";
import OverflowTooltip from "./columnEditors/OverflowTooltip";
import editImage from "images/edit.png";
import deleteImage from "images/delete2.png";
import { handleUpdatingData } from "app/websocketManager/eventEmitter";
import { handleDeletingColumn } from "app/websocketManager/eventEmitter";

import { getUniqueId } from "utils/Utils";
// import { reaction } from "mobx";
import { IoDuplicate } from "react-icons/io5";
import ReactDOMServer from "react-dom/server";

var isCellEditing = false,
  isDirectDeletion = false,
  isUndoRedoEditing = false,
  fillOperationInitialValues = [],
  fillOperationDirection = "";
const KEY_LEFT = 37,
  KEY_UP = 38,
  KEY_RIGHT = 39,
  KEY_DOWN = 40;
class Table extends Component {
  previousScrollTop = 0;

  constructor(props) {
    super(props);
    if (!props.isSubsheet) {
      //todo change this;
      window.appStore.currentViewStore = this.props.store;
    }
    this.actionButtonsPopperRef = React.createRef();
    this.updatedRowsData = {};

    this.state = {
      gridApi: {},
      networkDisconnected: false,
      windowResized: false,
      pinnedBottomRowData: [{}],
      defaultColDef: {
        editable: true,
        sortable: true,
        filter: true,
        resizable: true,
      },
      rangeSelectionCalculations: {
        selectedCellsCount: null,
        sum: null,
        average: null,
        minimum: null,
        maximum: null,
      },
      tooltipShowDelay: 0,
      groupRowInnerRenderer: "fullWidthGroupedCellRenderer",
      icons: {
        groupExpanded: '<div style="font-size: 30px">-</div>',
        groupContracted: '<div style="font-size: 18px">+</div>',
      },
      packName: "Timesheet",
      themeColor: COLORS.THEME_COLOR,
      icon: "7",
      sheets: ["Tracker", "Timesheet", "Sample Template", "Blank Template"],
      selectedSheet: "Timesheet",
      selectedSheetIndex: 1,

      getRowStyle: function (params) {
        let rowStyle = {};

        if (params.node.rowPinned) {
          rowStyle["font-weight"] = "bold";
        }
        if(params && params?.data && params?.data?.row_bg_color && params?.data?.row_bg_color != "") {
          let color = lightenColor(params.data.row_bg_color, 90);
          rowStyle["background-color"] = color;
        }
        return rowStyle;
      },
      getRowHeight: (params) => {
        if (params.node.detail) return;
        if (params.node.isRowPinned()) return DIMENSIONS.cell_height_dense;
        else if (params.node.group) return DIMENSIONS.grouped_row_height;
        return this.props.store.getRowHeight();
      },
    };
    this.handleUndoRedo = this.handleUndoRedo.bind(this);
    this.handleEnterKeyOnNewRow = this.handleEnterKeyOnNewRow.bind(this);
    this.handleDeleteOnRange = this.handleDeleteOnRange.bind(this);
    this.updateNetworkStatus = this.updateNetworkStatus.bind(this);
    this.onGridMouseOver = this.onGridMouseOver.bind(this);
    //todo check this;
    this.props.store.addGrid = this.addGrid.bind(this);
    this.props.store.redrawGridForGrouping = this.redrawGridForGrouping.bind(
      this
    );
    this.props.store.setRowHeight = this.setRowHeight.bind(this);
  }

  async componentDidMount() {
    document
      .querySelector("#" + this.props.store.gridId)
      .addEventListener("keydown", this.handleUndoRedo);
    window.addEventListener("online", this.updateNetworkStatus);
    window.addEventListener("offline", this.updateNetworkStatus);
    document
      .querySelector("#root")
      .addEventListener("mousedown", this.handleClickOutsideGrid);
    if (this.props.isSubsheet) {
      await this.fetchData();
    }
    this.addGrid();
  }

  updateNetworkStatus() {
    this.setState({ networkDisconnected: !navigator.onLine });
  }

  fetchData = async (params, fetchDuplicatesDataForLazyLoad = true) => {
    const { store } = this.props;
    await store.fetchUserEvents();
    if (store.columnDefs.length === 0 && !this.props.isSubsheet) {
      store.formatColumns();
    }
    if (store.allRowsData.length === 0 && store.shouldLoadAllRows) {
      await store.fetchData({}, true);
      if (store.allRowsData.length === 0 && store.newRows.length === 0) {
        this.addRow();
        this.addRow();
        this.addRow();
        this.addRow();
        this.addRow();
      }
    }
    if (params) {
      store.fetchDuplicatesDataForLazyLoad = store.isLazyLoadEnabled && fetchDuplicatesDataForLazyLoad ? true : false;
      store.addDataSource(params);
    }
  };

  onGridReady = (params, fetchDuplicatesDataForLazyLoad = true) => {
    this.params = params;
    this.props.store.params = params;
    this.gridApi = params.api;
    this.props.store.gridParams = params;
    this.props.store.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.props.store.onAgGridFilterChanged();
    // this.constructPinnedBottomData();
    var body = document.body;
    window.onresize = () => {
      this.setState({ windowResized: true });
    };
    this.setState({ gridApi: params.api });
    this.fetchData(params, fetchDuplicatesDataForLazyLoad);
    body.addEventListener("mouseup", (e) => {
      return;
      let gridDiv = document.getElementsByClassName(
        "ag-center-cols-container"
      )[0];
      if (
        !gridDiv.contains(e.target) &&
        this?.gridApi?.getFocusedCell()?.rowPinned !== "bottom" &&
        this?.gridApi?.getFocusedCell()?.column?.colDef?.cellRendererParams
          ?.columnTypeId === "8" &&
        !isCellEditing
      ) {
        params.api.clearFocusedCell();
      }
    });
    if (
      (this.props.isSubsheet && this.props.store.columns.length > 7) ||
      (this.isSubsheet &&
        this.columns.length < 7 &&
        params.columnApi.getDisplayedRightColumns().length > 0)
    ) {
      params.columnApi.applyColumnState({
        state: [{ colId: "$Events", pinned: "right" }],
      });
    }
    document
      .querySelector(`#${this.props.store.gridId}`)
      ?.addEventListener("mouseover", this.onGridMouseOver);
  };

  onGridMouseOver() {
    this.showActionButtonsPopper(...arguments);
    this.showErrorTooltip(...arguments);
    this.showOverflowTooltip(...arguments);
  }

  showOverflowTooltip = (e) => {
    const target =
      e.target.closest(".checkBoxChip") ||
      e.target.closest(".dropDownChip") ||
      e.target.closest(".multiSelectChip") ||
      e.target.closest(".pinnedRowText") ||
      e.target.closest(".triggerBtnForTooltip") ||
      e.target.closest(".email_clipped");
    const store = this.props.store;

    const highlightIconTarget = e.target.closest(".highlightIcon");
    if (highlightIconTarget !== null) {
      store.overflowTooltip.anchorEl = highlightIconTarget;
      store.overflowTooltip.value = "Duplicates found for this value";
      return;
    }

    const flashCellTarget = e.target.closest(".ag-cell-data-changed");
    if (flashCellTarget !== null) {
      store.overflowTooltip.anchorEl = flashCellTarget;
      store.overflowTooltip.value = "This value is updated by other user";
      return;
    }

    const fileTargets =
      e.target.closest(".loading_gif") || 
      e.target.closest(".file_icon_style");

      if(fileTargets!==null && (fileTargets.tagName==="IMG" || fileTargets.tagName=="SPAN") ){
      const isForLookUp = fileTargets.getAttribute("forLookUp");
      if(isForLookUp === "true"){
        store.overflowTooltip.anchorEl = fileTargets;
        store.overflowTooltip.value = e.target.getAttribute("alt");
        return;
      }
     }
     
    if (
      !target ||
      (target && e?.target?.scrollWidth <= e?.target?.clientWidth)
    ) {
      store.overflowTooltip.anchorEl = null;
      store.overflowTooltip.value = null;
      return;
    }
    store.overflowTooltip.anchorEl = target;
    store.overflowTooltip.value = e.target.innerText;
  };

  showErrorTooltip = (e) => {
    const target = e.target.closest(".ag-cell");
    const store = this.props.store;

    if (target?.getAttribute("role") !== "gridcell") {
      store.errorTooltip.anchorEl = null;
      store.errorTooltip.params = null;
      return;
    }

    let cellRendererParams =
      target[Object.keys(target)[0]].cellComp?.cellRenderer?.params;
    if (typeof cellRendererParams === "undefined"){
      cellRendererParams = target[Object.keys(target)[0]].cellComp?.cellRenderer?.agGridProps;
    }

    store.errorTooltip.anchorEl = target;
    store.errorTooltip.params = cellRendererParams;
  };

  showActionButtonsPopper = debounce(async (e) => {
    const target = e.target;
    const triggerAnchorEl = document.querySelector(
      `#${this.props.store.gridId} .ag-body-viewport .ag-pinned-left-cols-container .ag-row-hover`
    )?.children[0];

    if (this.props.store.isActionButtonsPopperOpen) {
      return;
    }
    if (!triggerAnchorEl && target?.getAttribute("role") === "tooltip") {
      return;
    }

    if (
      this.actionButtonsPopperRef.current?.parentNode?.querySelector(":hover")
    ) {
      return;
    }

    if (
      triggerAnchorEl &&
      this.props.store.actionButtons.anchorEl !== triggerAnchorEl
    ) {
      this.props.store.actionButtons.anchorEl = triggerAnchorEl;
      this.props.store.actionButtons.currentRowNode =
        triggerAnchorEl[Object.keys(triggerAnchorEl)[0]]?.cellComp?.rowNode;
    }
    if (!triggerAnchorEl) {
      this.hideActionButtons();
    }
  }, 100);

  hideActionButtons = () => {
    this.props.store.actionButtons.anchorEl = null;
    this.props.store.isActionButtonsPopperOpen = false;
    this.props.store.actionButtons.currentRowNode = null;
  };
 
  constructPinnedBottomData() {
    var result = {} , decimalsInfo = {}
    var columnsWithAggregation = this.props.store.columnsWithAggregation;
    var columnDataFields = Object.keys(columnsWithAggregation);
    this.gridColumnApi.getAllGridColumns().forEach((item) => {
      if(item.colDef?.cellRendererParams?.columnTypeId == 22){
        decimalsInfo[item.colDef["field"]] = item.colDef.cellRendererParams.columnOptions?.decimals ?? 2
      }
      result[item.colDef["field"]] = columnDataFields.includes(
        item.colDef["field"]
      )
        ? 0
        : "";
    });
    var pinnedBottomRowData = [];
    pinnedBottomRowData.push(
      this.calculatePinnedBottomData(result, columnDataFields, decimalsInfo)
    );
    this.gridApi.setPinnedBottomRowData(pinnedBottomRowData);
    this.setState({ pinnedBottomRowData: pinnedBottomRowData });
  }

  calculatePinnedBottomData = (target, columnDataFields, decimalsInfo = {}) => {
    var value = 0,
      initialValueStored = false;
    //list of columns for aggregation
    if (this.props.store.isLazyLoadEnabled == true) {
      return target;
    }
    columnDataFields.forEach((element, index) => {
      var count = 0;

      this.gridApi.forEachNodeAfterFilter((rowNode) => {
        if (rowNode?.data?.[element] != "+r0w") count++;
        if (
          Number(rowNode?.data?.[element]) ||
          Number(rowNode?.data?.[element]).toFixed(0) == 0
        ) {
          if (
            this.props.store.columnsWithAggregation[element] === "Sum" ||
            this.props.store.columnsWithAggregation[element] === "Avg"
          ) {
            target[element] += Number(Number(rowNode.data[element]).toFixed(decimalsInfo[element] ?? 2));
          } else {
            if (!initialValueStored) {
              value = Number(rowNode.data[element]);
              target[element] = value;
              initialValueStored = true;
            }
            if (this.props.store.columnsWithAggregation[element] === "Min") {
              if (value > Number(rowNode.data[element])) {
                value = Number(rowNode.data[element]);
                target[element] = value;
              }
            }
            if (this.props.store.columnsWithAggregation[element] === "Max") {
              if (value < Number(rowNode.data[element])) {
                value = Number(rowNode.data[element]);
                target[element] = value;
              }
            }
          }
        }
        return 0;
      });
      if (this.props.store.columnsWithAggregation[element] === "Avg") {
        target[element] = target[element] / count;
      }
      target[element] = `${
        this.props.store.columnsWithAggregation[element]
      }: ${target[element]?.toFixed(decimalsInfo[element] ?? 2)}`;
      initialValueStored = false;
    });
    return target;
  };

  addRow = (newRowInitialData = {}, columnId = null) => {
    if (this.props.store.isSubsheet && this.props.store.parentListId) {
      const parentListContainerStore = window.appStore.getCurrentListContainerStore(this.props.store.parentListId);
      const hasEditPermissions = parentListContainerStore?.permissions?.canEdit(this.props.store.parentColumnId, this.props.store.parentRow);
      if (hasEditPermissions && !hasEditPermissions[0]) {
        window.appStore.notificationStore.showNotification(
          "You don't have permission to add a row in this subsheet",
          "caution"
        );
        return;
      }
    }
    if (
      this.props.store.isSubsheet ||
      this.props?.store?.containerStore?.permissions?.canAdd()
    ) {
      if (this.props.isAddRowDisabled) {
        if (
          this.props.store.isSubsheet &&
          Object.keys(newRowInitialData).length > 0
        ) {
          window.appStore.notificationStore.showNotification(
            "Cannot add a new row. You are in edit-field mode",
            "caution"
          );
        }
        return;
      }
      const newRow = this.props.store.getNewRow(newRowInitialData);
      if (this.props.store.isGridGrouped) {
        this.gridApi.applyTransaction({ remove: [newRowInitialData] });
        this.gridApi.applyTransaction({
          add: [newRow, newRowInitialData],
        });
      } else {
        try {
          if (this.props.store.isLazyLoadEnabled == true) {
            let maxRowFound = this.gridApi.isLastRowIndexKnown();
            if (maxRowFound) {
              let rowCount = this.gridApi.getInfiniteRowCount();
              this.gridApi.setRowCount(rowCount + 1);
            }
            this.gridApi.purgeInfiniteCache();
          } else {
            this.gridApi.applyTransaction({
              add: [newRow],
              addIndex: this.props.store.allVisibleGridRowsCount - 2,
            });
          }
        } catch (error) {
          if (
            this.props.store.isRowAdded == true &&
            this.props.store.isLazyLoadEnabled == true
          ) {
            this.gridApi.setFocusedCell(
              this.props.store.allVisibleGridRowsCount - 2,
              columnId
            );
            this.props.store.isRowAdded = false;
          }
        }
      }
      this.ensureNewRowVisible();
    } else {
      window.appStore.notificationStore.showNotification(
        "You don't have permission to add new records.",
        "caution"
      );
    }
  };

  ensureNewRowVisible = () => {
    if (this.props.store.isGridGrouped) {
      return;
    }

    let count = 0;
    this.gridApi?.forEachNode(function (node) {
      if (node.group) {
        count += 1;
      }
      return 0;
    });
    this.gridApi?.ensureIndexVisible(
      count === 0 ? this.props.store.allVisibleGridRowsCount - 1 : count,
      "bottom"
    );
  };

  columnResized = (e) => {
    if (e.finished) {
      var columnDefs = this.props.store.columnDefs;
      e.columns.map((column, index) => {
        for (let i = 0; i < columnDefs.length; i++) {
          if (columnDefs[i]["colId"] === column["colId"]) {
            columnDefs[i]["width"] = column.actualWidth;
          }
        }
        return 0;
      });
      e.api.setColumnDefs(columnDefs);

      this.props.store.handleViewColumnsWidthChanged(e.columns);
      setTimeout(() => {
        this.gridApi.redrawRows();
      }, 1);
    }
  };

  setRowHeight = (height) => {
    this.props.store.handleRowHeightChange(height);
    if (!this.props.store.shouldLoadAllRows) {
      this.addGrid(false);
      return;
    }

    this.gridApi.resetRowHeights();
    setTimeout(() => {
      this.gridApi.redrawRows();

      if (height > DIMENSIONS.cell_height_dense) {
        let array = Array.from(document.getElementsByClassName("ag-checkbox"));
        array.map((cell) => {
          cell.classList.add("ag-checkbox-high-padding");
        });
      } else {
        let array = Array.from(document.getElementsByClassName("ag-checkbox"));
        array.map((cell) => {
          cell.classList.remove("ag-checkbox-high-padding");
        });
      }
    }, 1);
  };

  shouldStartEditing = (e) => {
    // if (e.rowIndex === this.props.store.allSavedRowsCount) {
    //   window.addEventListener("keydown", this.handleEnterKeyOnNewRow);
    // } else {
    //   window.removeEventListener("keydown", this.handleEnterKeyOnNewRow);
    // }
  };

  handleEnterKeyOnNewRow = (event) => {
    if ([13].indexOf(event.keyCode) > -1) {
      this.addRow();
    }
  };


  handleClickOutsideGrid = (event) => {
    if (event.target.closest(".ag-menu-option-part.ag-menu-option-text")) {
      return;
    }
    let closestCheckboxElement = event.target.closest(
      ".checkbox_cell_inline_editing"
    );
    
    let closestMultilineElement = event.target.closest(
      ".multiline_cell_inline_editing"
    );
    let closestCommentsElement = event.target.closest(
      ".comments_cell_inline_editing"
    );
    if( 
      this.gridApi?.getFocusedCell()?.column?.colDef?.cellRendererParams
    ?.columnTypeId === "comments_id" && !closestCommentsElement
    ){
    this.gridApi.clearRangeSelection();
    this.gridApi.clearFocusedCell();
    }

    if( 
      this.gridApi?.getFocusedCell()?.column?.colDef?.cellRendererParams
    ?.columnTypeId === "8" && !closestMultilineElement 
    ){
    this.gridApi.clearRangeSelection();
    this.gridApi.clearFocusedCell();
    }

    if (
      !closestCheckboxElement &&
      this.gridApi?.getFocusedCell()?.column?.colDef?.cellRendererParams
        ?.columnTypeId === "13"
    ) {
      this.gridApi.clearRangeSelection();
      this.gridApi.clearFocusedCell();
      this.props.store.prevClickedCellRowId = "";
      this.props.store.prevClickedCellColumnId = "";
    }
  };

  changePackName = (name) => {
    this.setState({
      packName: name,
    });
  };

  changeThemeColor = (color) => {
    this.setState({
      themeColor: color,
    });
  };

  changeIcon = (icon) => {
    this.setState({
      icon: icon,
    });
  };

  renameSheet = (name) => {
    var sheets = this.state.sheets;
    sheets[this.state.selectedSheetIndex] = name;
    this.setState({
      selectedSheet: name,
      sheets: sheets,
    });
  };

  rowClicked = (e) => {
    if (
      e?.data?.row_id === "+" &&
      this.props?.view?.type == "table" &&
      this.props?.view?.list_id &&
      this.props?.view?.options?.main_list_id &&
      this.props?.view?.list_id != this.props?.view?.options?.main_list_id
    ) {
      window.appStore.notificationStore.showNotification(
        "You can't add new row in this view",
        "info"
      );
      return;
    }  
  
    if (e?.data?.row_id === "+") {
      const focusedCell = this.gridApi.getFocusedCell();
      if (
        this.gridApi?.getFocusedCell()?.column?.colDef?.cellRendererParams
          ?.columnTypeId === "8" ||
        this.gridApi?.getFocusedCell()?.column?.colDef?.cellRendererParams
          ?.columnTypeId === "13"
      ) {
        this.gridApi.clearRangeSelection();
        this.gridApi.clearFocusedCell();
        setTimeout(()=>{
          this.gridApi.setFocusedCell(focusedCell?.rowIndex,focusedCell?.column?.colId)
        },1);
      }
      this.addRow(e.data);
    } else {
      e.node.setExpanded(!e.node.expanded);
    }
  };

  processCellValueForClipboard = (params) => {
    if (params.column.colDef.cellRendererParams.columnTypeId === "4") {
      return Moment(params.value).format("YYYY-MM-DD");
    }
    if (params?.column?.colDef?.cellRendererParams?.columnTypeId === "22") {
      let decimals = String(params.value).includes(".") ? String(params.value).split(".")[1].length : 2
      return String((Number(params.value)*100).toFixed(decimals - 2))
    }
    if (params?.column?.colDef?.cellRendererParams?.columnTypeId === "10") {
      if(params.column.colDef.cellRendererParams.columnOptions.column_type == "percentage"){
        let decimals = String(params.value).includes(".") ? String(params.value).split(".")[1].length : 2
        return String((Number(params.value)*100).toFixed(decimals - 2))
      }
    }
    return params.value;
  };

  processDataFromClipboard = (params) => {
    let { data } = params;
    data = data.filter((record, index) => {
      return !(record.length === 1 && record[0] === "" && index === data.length - 1);
    }); 
    // let reducedToString = data.map(strArray => strArray[0]).join("\n");
    // const outputString = [];
    // outputString.push([reducedToString]);
    // return outputString;
    if (data.length > 1) {
      if (data.length > 1000 && this.props.store?.isLazyLoadEnabled) {
        window.appStore.notificationStore.showNotification(
          "Only 1000 records will be pasted at a time in this view.",
          "info"
        );
      } else if (this.props.store?.shouldLoadAllRows && data.length > 50) {
        window.appStore.notificationStore.showNotification(
          "Pasting in progress.Please allow a moment for the process to complete.",
          "info"
        );
      }
      const focusedCell = this.gridApi?.getFocusedCell();
      let displayedRowsCount = this.gridApi?.getDisplayedRowCount() - 1;
      let newRowsLength =
        focusedCell.rowIndex + 1 >= displayedRowsCount
          ? data.length - 1
          : data.length - (displayedRowsCount - focusedCell.rowIndex);
      if (this.props.store?.isLazyLoadEnabled) {
        newRowsLength =
          this.props.store?.newRows.length >= 1000
            ? 0
            : newRowsLength > 990
            ? 1000
            : (this.props.store?.newRows.length > data.length ? 0 : (data.length - (displayedRowsCount - focusedCell.rowIndex)));
      }
      for (let i = 0; i < newRowsLength; i++) {
        if (this.props.store?.isLazyLoadEnabled) {
          this.props.store.getNewRow({});
          if (i == newRowsLength - 1) {
            this.gridApi.purgeInfiniteCache();
            window.appStore.notificationStore.showNotification(
              "Preparing space for your data… Please try pasting again in 1–2 seconds.",
              "info"
            );
          }
        } else if (this.props.store?.shouldLoadAllRows) {
          this.addRow();
        }
      }
    }
    return data;
  };

  postProcessPopup = (params) => {
    let columnTypeId = params.column?.colDef?.cellRendererParams?.columnTypeId;
    let popupRight = Number(params.ePopup?.getBoundingClientRect().right);
    if (
      (columnTypeId == 4 || columnTypeId == 16) &&
      Number(window.innerWidth) - popupRight <= 30
    ) {
      let ePopup = params.ePopup;
      ePopup.style.left =
        Number(params.ePopup?.getBoundingClientRect().left) - 50 + "px";
    }
  };

  pasteEnded = (params) => {
    if (
      this.props.store.isPasteSuccess == false &&
      (this.props.store.isReadOnlyCell == true ||
        this.props.store.pasteColumnTypeId === "6" ||
        this.props.store.pasteColumnTypeId === "7" ||
        this.props.store.pasteColumnTypeId === "19")
    ) {
      if (this.props.store.pasteColumnTypeId === "6") {
        Ext.Msg.alert(
          "Error",
          "Please open subsheet to paste data inside subsheet."
        );
      } else {
        Ext.Msg.alert(
          "Error",
          "You cannot paste data into an uneditable cell."
        );
      }
    }
    this.props.store.isPasteSuccess = false;
    if (Object.keys(this.updatedRowsData).length > 0) {
      var modifiedData = {};
      let childNodeWhileGrouped = '';
      Object.entries(this.updatedRowsData).forEach(([rowId, columnData]) => {
        const node = this.props.store?.getRowNodeById(rowId)?.node;
        if (node && node?.data) {
          childNodeWhileGrouped = node;
          columnData.forEach(column => {
            if (!modifiedData[node.data.row_id]) {
              modifiedData[node.data.row_id] = [node.data, {'columnName': column.columnName, 'columnPath': column.columnPath}];
            } else {
              modifiedData[node.data.row_id].push({'columnName': column.columnName, 'columnPath': column.columnPath});
            }
          });
        }
        delete this.updatedRowsData[rowId];
      });
      if (Object.keys(modifiedData).length > 0) {
        this.props.store.refreshGroupedColHeaderWhileUpdation(childNodeWhileGrouped);
        handleUpdatingData(JSON.stringify(modifiedData), '', this.props.store.listId, this.props.store.isSubsheet);
      }
    }
    if (this.props.store?.isLazyLoadEnabled) {
      if (window.LOGGED_IN_USER?.domain && window.LOGGED_IN_USER.domain == "aryamotors") {
        setTimeout(() => {
          this.gridApi.purgeInfiniteCache();
        }, 1000);
      }
    }
  };

  hideColumn = (params) => {
    var columnDefs = this.props.store.columnDefs,
      index = 0;
    for (let i = 0; i < columnDefs.length; i++) {
      if (params.column.colId === columnDefs[i].colId) {
        if (params.column.colId === "commentsId") {
          if(typeof this.props?.store?.view?.options?.options === "undefined"){ 
            this.props.store.review.options.options = {
              is_comments_column_visible : false
            } 
          }
          else if ( typeof this.props.store.view.options.options.is_comments_column_visible =="undefined" || this.props.store.view.options.options.is_comments_column_visible == true) {
            this.props.store.view.options.options.is_comments_column_visible = false;
          } else {
              this.props.store.view.options.options.is_comments_column_visible = true;
          }
        }
        index = i;
        break;
      }
    }
    columnDefs[index]["isVisible"] = false;
    columnDefs[index]["hide"] = true;
    params.api.columnController.columnApi.setColumnVisible(
      columnDefs[index]["colId"],
      false
    );
    // this.updateColumnDefs(index);
  };

  async deleteColumnWithConfirmation(params) {
    try {
      await window.appStore.notificationStore.confirm({
        description: (
          <>
            This action will permanently delete column{" "}
            <b>{params.column.colDef.cellRendererParams.columnRaw.name}</b>
          </>
        ),
      });
      this.deleteColumn(params);
    } catch (e) {}
  }

  deleteColumn = async (params) => {
    const store = this.props.store;
    const columnId = params.column.colDef.cellRendererParams.columnRaw.id;

    store.isColumnDeleting = true;
    const isDeleted =
      (await store.containerStore?.handleDeleteColumn(columnId)) ||
      (await this.props.handleColumnDelete?.(columnId));
    store.isColumnDeleting = false;

    if (!isDeleted) {
      return;
    }

    handleDeletingColumn(columnId, store.listId, store.isSubsheet, store.isSubsheet ? store?.parentListId : "");

    var columnDefs = store.columnDefs,
      index = -1;

    for (let i = 0; i < columnDefs.length; i++) {
      if (params.column.colId === columnDefs[i].colId) {
        index = i;
        break;
      }
    }

    if(index >= 0) {
      columnDefs.splice(index, 1);
      params.api.setColumnDefs(columnDefs);
    }
  };

  sortAscending(params) {
    var columnDefs = this.props.store.columnDefs,
      index = 0;
    for (let i = 0; i < columnDefs.length; i++) {
      if (
        this.props.store.columnDefs[i].sort === "asc" ||
        this.props.store.columnDefs[i].sort === "desc"
      ) {
        this.props.store.columnDefs[i].sort = "";
      }
      if (params.column.colId === columnDefs[i].colId) {
        index = i;
      }
    }
    if (!params.column.isSortAscending()) {
      params.api.setSortModel([
        {
          colId: params.column.colId,
          sort: "asc",
        },
      ]);
      columnDefs[index]["sort"] = "asc";
    } else {
      params.api.setSortModel([
        {
          colId: params.column.colId,
          sort: "",
        },
      ]);
      columnDefs[index]["sort"] = "";
    }
  }

  sortDescending(params) {
    var columnDefs = this.props.store.columnDefs,
      index = 0;
    for (let i = 0; i < columnDefs.length; i++) {
      if (
        this.props.store.columnDefs[i].sort === "asc" ||
        this.props.store.columnDefs[i].sort === "desc"
      ) {
        this.props.store.columnDefs[i].sort = "";
      }
      if (params.column.colId === columnDefs[i].colId) {
        index = i;
      }
    }
    if (!params.column.isSortDescending()) {
      params.api.setSortModel([
        {
          colId: params.column.colId,
          sort: "desc",
        },
      ]);
      columnDefs[index]["sort"] = "desc";
    } else {
      params.api.setSortModel([
        {
          colId: params.column.colId,
          sort: "",
        },
      ]);
      columnDefs[index]["sort"] = "";
    }
  }

  postSort = (rowNodes) => {
    if (this.props.store.newRows.length > 0) {
      const newRowNodes = [];
      for (let i = 0; i < rowNodes.length; i++) {
        if (isEmpty(rowNodes[i]?.data?.row_id)) {
          const rowNode = rowNodes.splice(i, 1)[0];
          i--;
          newRowNodes.push(rowNode);
        }
      }
      rowNodes.push(...newRowNodes);
    }

    if (
      rowNodes.length &&
      rowNodes[rowNodes.length - 1]?.data?.row_id !== "+"
    ) {
      for (let i = 0; i < rowNodes.length; i++) {
        if (rowNodes[i]?.data?.row_id === "+") {
          rowNodes.splice(rowNodes.length - 1, 0, rowNodes.splice(i, 1)[0]);
          break;
        }
      }
    }
  };

  groupColumn(params) {
    var columnDefs = this.props.store.columnDefs,
      previousShouldLoadAllRows = this.props.store.shouldLoadAllRows,
      index = 0,
      rowGroupIndex = 0;
    for (let i = 0; i < columnDefs.length; i++) {
      if (params.column.colId === columnDefs[i].colId) {
        index = i;
      }
      if (columnDefs[i].rowGroupIndex > rowGroupIndex) {
        rowGroupIndex = columnDefs[i].rowGroupIndex;
      }
    }
    columnDefs[index]["rowGroup"] = !columnDefs[index]["rowGroup"];
    columnDefs[index]["rowGroupIndex"] = columnDefs[index]["rowGroup"]
      ? rowGroupIndex + 1
      : null;
    if (
      columnDefs[index]["rowGroupIndex"] == null &&
      (columnDefs[index].cellRendererParams?.columnTypeId == "4" ||
        columnDefs[index].cellRendererParams?.columnTypeId == "16")
    ) {
      columnDefs[index]["rowGroupOption"] = "my";
    }
    this.updateColumnDefsKeyCreator(index);
    this.redrawGridForGrouping(previousShouldLoadAllRows);
  }

  updateColumnDefsKeyCreator = (index) => {
    this.props.store.columnDefs[index].keyCreator = (params) => {
      if(params.value !== '+r0w'){
        return this.props.store.getKeyCreatorValue(
          params,
          this.props.store.columnDefs[index]
        );
      }
    };
  }

  getContextMenuItems = (...args) => {
    console.log(args);
    return ["copy", "copyWithHeaders", "paste", "separator", "export"];
  };

  getMainMenuItems = (params) => {
    var menuItems = [];
    const column = params.column.colDef.cellRendererParams.columnRaw;
    let listColumn;
    if (this.props.isSubsheet) {
      listColumn = this.props.columns?.find(
        (listCol) => listCol.alias_path === column.alias_path
      );
    } else {
      listColumn = this.props.store.listConfig?.listData.find(
        (listCol) => listCol.alias_path === column.alias_path
      );
    }
    const isDefaultColumn =
      !listColumn ||
      parseInt(listColumn.default_type) === 1 ||
      parseInt(listColumn.is_default) === 1;
    if (params.column.colId !== "Id" && params.column?.colId !== "Parent Row Id") {
      menuItems.push("pinSubMenu", "separator");
      if (!this.props.store.isTableConfigReadOnly && !isDefaultColumn) {
        menuItems.push({
          name: "Edit this field",
          action: () =>
            this.props.store.showAddColumn(
              params.column.colDef.cellRendererParams.columnId, "edit"
            ),
          icon: `<img src="${editImage}" style="width: 14px;"/>`,
        });
        if (params.column.colDef.cellRendererParams.columnTypeId != "6") {
          menuItems.push({
              name: "Duplicate this field",
              action: () =>
                  this.props.store.showAddColumn(
                      params.column.colDef.cellRendererParams.columnId, "duplicate", this.gridApi
                  ),
              icon: ReactDOMServer.renderToStaticMarkup( <IoDuplicate/> ),
          });
        }
      }
      if (!this.props.isHideColumnHidden ) {
        menuItems.push({
          name: "Hide this column",
          action: () => this.hideColumn(params),
          icon: '<span class="ag-icon ag-icon-eye-slash"></span>',
        });
        menuItems.push("separator");
      }
    }

    if (!this.props.isSortingHidden && params.column.colId !== "commentsId") {
      menuItems.push({
        name: "Sort A-Z",
        action: () => this.sortAscending(params),
        icon: '<span class="ag-icon ag-icon-asc"></span>',
      });
      menuItems.push({
        name: "Sort Z-A",
        action: () => this.sortDescending(params),
        icon: '<span class="ag-icon ag-icon-desc"></span>',
      });
    }
    if (params.column.colId !== "Id" && params.column?.colId !== "Parent Row Id" && params.column.colId !== "commentsId") {
      if (!this.props.store.isTableConfigReadOnly && !isDefaultColumn) {
        menuItems.push("separator");
        menuItems.push({
          name: "Delete this field",
          action: () => this.deleteColumnWithConfirmation(params),
          icon: `<img src="${deleteImage}"/>`,
        });
      }
      if (!this.props.isGroupByHidden) {
        menuItems.push("separator");
        menuItems.push({
          name: params.column.colDef.rowGroup
            ? "Ungroup this column"
            : "Group this column",
          action: () => this.groupColumn(params),
          icon: '<span class="ag-icon ag-icon-group"></span>',
        });
      }
    }
    return menuItems;
  };

  onFilterChanged = (params) => {
    this.props.store.onAgGridFilterChanged(params);
    try {
      this.constructPinnedBottomData();
    } catch (e) {
      console.log(e);
    }
  };

  updateUndoStack(modifiedValues) {
    this.props.store.undoStack.push(modifiedValues);
  }

  setFocusedCellAfterUndoRedo = (poppedData) => {
    poppedData[0].rowNode.gridApi.clearRangeSelection();
    poppedData[0].rowNode.gridApi.clearFocusedCell();
    if (poppedData.length === 1) {
      poppedData[0].rowNode.gridApi.setFocusedCell(
        poppedData[0].rowNode.rowIndex,
        poppedData[0].colDef.colId
      );
    } else {
      if (poppedData[0]?.isFillOperation === true) {
        poppedData[0].rowNode.gridApi.setFocusedCell(
          poppedData[0].focusedCellRowId,
          poppedData[0].focusedCellColId
        );
      } else {
        poppedData[0].rowNode.gridApi.addCellRange({
          rowStartIndex: poppedData[0].rowNode.rowIndex,
          rowEndIndex: poppedData[poppedData.length - 1].rowNode.rowIndex,
          columnStart: poppedData[0].colDef.colId,
          columnEnd: poppedData[poppedData.length - 1].colDef.colId,
        });
        poppedData[0].rowNode.gridApi.setFocusedCell(
          poppedData[0].focusedCellRowId,
          poppedData[0].focusedCellColId
        );
      }
    }
  };

  handleUndoRedo = (event) => {
    if (
      (event.ctrlKey || event.metaKey || [91, 93].indexOf(event.keyCode) > -1) &&
      [90, 89].indexOf(event.keyCode) > -1
    ) {
      event.stopImmediatePropagation();
      if (!event.shiftKey && event.keyCode == 90) {
        if (this.props.store.undoStack.length) {
          var poppedData = this.props.store.undoStack.pop();
          isUndoRedoEditing = true;
          poppedData.map((item) => {
            this.props.store.handleCellValueChanged({
              colDef: item.colDef,
              api: this.gridApi,
              node: item.rowNode,
              newValue: item.newValue,
              oldValue: item.oldValue,
            });
          });
          this.setFocusedCellAfterUndoRedo(poppedData);
          this.props.store.redoStack.push(poppedData);
        }
      } else {
        if (this.props.store.redoStack.length) {
          var poppedData = this.props.store.redoStack.pop();
          isUndoRedoEditing = true;
          poppedData.map((item) => {
            this.props.store.handleCellValueChanged({
              colDef: item.colDef,
              api: this.gridApi,
              node: item.rowNode,
              newValue: item.oldValue,
              oldValue: item.newValue,
            });
          });
          this.setFocusedCellAfterUndoRedo(poppedData);
          this.props.store.undoStack.push(poppedData);
        }
      }
    }
  };

  handleDeleteOnRange(event) {
    const cellRanges = this.gridApi.getCellRanges();
    const focusedCell = this.gridApi.getFocusedCell();
    var modifiedValues = [];

    if (
      document.activeElement.id !== "findText" &&
      !isCellEditing &&
      [46, 8].indexOf(event.keyCode) > -1
    ) {
      isDirectDeletion = true;
      this.gridApi.stopEditing();
      cellRanges.map((range) => {
        const startRow = Math.min(
          range.startRow.rowIndex,
          range.endRow.rowIndex
        );
        const endRow = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);

        for (var rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
          range.columns.forEach((column) => {
            if (column.colDef.field !== "row_id") {
              // or this.gridApi.getModel().rowsToDisplay[INDEX] //todo: check after filters applied
              const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
              var obj = {};

              if (Number(rowNode.id) || rowNode.id.includes("unique_")) {
                obj.rowNode = rowNode;
                obj.colDef = column.colDef;
                obj.newValue = this.gridApi.getValue(column.colDef, rowNode);
                obj.oldValue = "";
                obj.focusedCellRowId = focusedCell.rowIndex;
                obj.focusedCellColId = focusedCell.column.colId;
                obj.isFillOperation = false;
                modifiedValues.push(obj);
              }

              this.props.store.handleCellValueChanged({
                colDef: column.colDef,
                api: this.gridApi,
                node: rowNode,
                newValue: "",
                oldValue: "",
                is_deleted: true
              });
            }
          });
        }
      });
      this.gridApi.setFocusedCell(
        focusedCell.rowIndex,
        focusedCell.column.colId
      );
      this.constructPinnedBottomData();
      this.updateUndoStack(modifiedValues);
    }
  }

  handleFillCells(params) {
    var modifiedValues = [];
    let modifiedRowAndColumnData = {};
    const startRow = params.finalRange.startRow.rowIndex;
    const endRow = params.finalRange.endRow.rowIndex;
    const focusedCell = this.gridApi.getFocusedCell();
    let rowId = 0;
    for (var rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
      params.finalRange.columns.forEach((column, index) => {
        if (column.colDef.field !== "row_id") {
          // or this.gridApi.getModel().rowsToDisplay[INDEX] //todo: check after filters applied
          const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
          var obj = {},
            value = this.gridApi.getValue(column.colDef, rowNode);
          let previousValue = "";
          if (startRow === endRow && params.finalRange.columns.length > 0) {
            previousValue =
              fillOperationDirection === "original"
                ? index === 0
                  ? value
                  : fillOperationInitialValues[index - 1]
                : index === params.finalRange.columns.length - 1
                ? value
                : fillOperationInitialValues[index];
          } else {
            previousValue =
              fillOperationDirection === "original"
                ? rowId === 0
                  ? value
                  : fillOperationInitialValues[rowId - 1]
                : rowIndex === endRow
                ? value
                : fillOperationInitialValues[rowId];
          }

          if (Number(rowNode.id) || rowNode.id.includes("unique_")) {
            obj.rowNode = rowNode;
            obj.colDef = column.colDef;
            obj.newValue = previousValue || "";
            obj.oldValue = value;
            obj.focusedCellRowId = focusedCell.rowIndex;
            obj.focusedCellColId = focusedCell.column.colId;
            obj.isFillOperation = true;
            modifiedValues.push(obj);
            var nodeData = rowNode?.data ? rowNode.data : '';
            if (nodeData && nodeData?.row_id) {
              if (!modifiedRowAndColumnData[nodeData.row_id]) {
                modifiedRowAndColumnData[nodeData.row_id] = [nodeData, {'columnName': column?.colDef?.cellRendererParams?.columnRaw?.name, 'columnPath': column.colDef.aliasPath}];
              } else {
                modifiedRowAndColumnData[nodeData.row_id].push({'nodeData': nodeData, 'columnName': column?.colDef?.cellRendererParams?.columnRaw?.name, 'columnPath': column.colDef.aliasPath});
              }
            }
          }

          this.props.store.handleCellValueChanged({
            colDef: column.colDef,
            api: this.gridApi,
            node: rowNode,
            newValue: value,
            oldValue: value,
            previousValue: previousValue,
            isFilling: true
          });
        }
      });
      rowId += 1;
    }
    try {
      if (Object.keys(modifiedRowAndColumnData).length > 0) {
        const childNodeWhileGrouped = this.gridApi.getDisplayedRowAtIndex(startRow);
        this.props.store.refreshGroupedColHeaderWhileUpdation(childNodeWhileGrouped);
        handleUpdatingData(JSON.stringify(modifiedRowAndColumnData), '', this.props.store.listId, this.props.store.isSubsheet);
      }
    } catch (error) {
      console.log('Error', error);
    }
    this.updateUndoStack(modifiedValues);
    fillOperationInitialValues = [];
    fillOperationDirection = "";
    this.gridApi.refreshCells();
    this.props.store.isFilling = false;
  }

  onRangeSelectionChanged = (event) => {
    var rangeSelectionCalculations = this.state.rangeSelectionCalculations;
    document
      .querySelector(
        "#" +
          this.props.store.gridId +
          " .ag-body-viewport.ag-layout-normal.ag-row-animation"
      )
      .removeEventListener("keydown", this.handleDeleteOnRange);
    document
      .querySelector(
        "#" +
          this.props.store.gridId +
          " .ag-body-viewport.ag-layout-normal.ag-row-animation"
      )
      .addEventListener("keydown", this.handleDeleteOnRange);
    var cellRanges = this.gridApi.getCellRanges();
    if (!cellRanges || cellRanges.length === 0) {
      rangeSelectionCalculations.selectedCellsCount = null;
      rangeSelectionCalculations.sum = null;
      rangeSelectionCalculations.average = null;
      rangeSelectionCalculations.minimum = null;
      rangeSelectionCalculations.maximum = null;
      this.setState({
        rangeSelectionCalculations: rangeSelectionCalculations,
      });
      return;
    }
    rangeSelectionCalculations.selectedCellsCount = cellRanges.length;

    var sum = 0,
      average = 0,
      selectedCellsCount = 0;
    cellRanges.map((range) => {
      if (range?.startRow?.rowIndex >= 0 && range?.endRow?.rowIndex >= 0) {
        var startRow = Math.min(range.startRow.rowIndex, range.endRow.rowIndex);
        var endRow = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
        for (var rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
          range.columns.forEach((column) => {
            var rowModel = this.gridApi.getModel();
            var rowNode = rowModel.getRow(rowIndex);
            var value = this.gridApi.getValue(column, rowNode);
            if (typeof value === "number" || (value && value.length)) {
              selectedCellsCount += 1;
            }
            if (Number(value) || (value + "").split(".")[0] === "0") {
              sum += Number(value);
            }
            return 0;
          });
        }
        average = sum / selectedCellsCount;
        return 0;
      }
    });
    if (event.finished) {
      var minimum = 0,
        maximum = 0,
        initialValueStored = false;

      cellRanges.map((range) => {
        if (
          range?.startRow?.rowIndex != undefined &&
          range?.endRow?.rowIndex != undefined
        ) {
          var startRow = Math.min(
            range.startRow.rowIndex,
            range.endRow.rowIndex
          );
          var endRow = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
          for (var rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
            range.columns.forEach((column) => {
              var rowModel = this.gridApi.getModel();
              var rowNode = rowModel.getRow(rowIndex);
              var value = this.gridApi.getValue(column, rowNode);
              if (Number(value) || (value + "").split(".")[0] === "0") {
                if (!initialValueStored) {
                  minimum = Number(value);
                  maximum = Number(value);
                  initialValueStored = true;
                }
                if (minimum > Number(value)) {
                  minimum = Number(value);
                }
                if (maximum < Number(value)) {
                  maximum = Number(value);
                }
              }
            });
          }
          return 0;
        }
      });

      rangeSelectionCalculations.sum = sum;
      rangeSelectionCalculations.average = average;
      rangeSelectionCalculations.minimum = minimum;
      rangeSelectionCalculations.maximum = maximum;
      rangeSelectionCalculations.selectedCellsCount = selectedCellsCount;

      this.setState({ rangeSelectionCalculations: rangeSelectionCalculations });
    }
  };

  onBodyScroll = (params) => {
    const eBodyViewPort = params.api.gridPanel.eBodyViewport;
    if (
      params.direction == "vertical" &&
      params.top > 0 &&
      this.previousScrollTop < params.top &&
      eBodyViewPort.scrollTop !=
        eBodyViewPort.scrollHeight - eBodyViewPort.offsetHeight
    ) {
      this.props.store.isScrollToLastButtonVisible = true;
    } else {
      this.props.store.isScrollToLastButtonVisible = false;
    }
    this.previousScrollTop = params.direction == "vertical" ? params.top : 0;

    //todo: change this it executes for all ag grid components in grid
    if (params.top > 0) {
      document
        .getElementsByClassName("ag-header")[0]
        .classList.add("header-shadow");
      document
        .getElementsByClassName("ag-floating-bottom")[0]
        .classList.add("footer-shadow");
    } else {
      document
        .getElementsByClassName("ag-header")[0]
        .classList.remove("header-shadow");
      document
        .getElementsByClassName("ag-floating-bottom")[0]
        .classList.remove("footer-shadow");
    }
    if (params.left > 0) {
      let parentDOM = document.getElementById(this.props.store.gridId);
      parentDOM
        .getElementsByClassName("ag-pinned-left-cols-container")[0]
        .classList.add("row-id-column-shadow");
      parentDOM
        .getElementsByClassName("ag-pinned-left-header")[0]
        .classList.add("row-id-column-shadow");
      parentDOM
        .getElementsByClassName("ag-pinned-right-cols-container")[0]
        .classList.add("row-id-column-shadow");
      parentDOM
        .getElementsByClassName("ag-pinned-right-header")[0]
        .classList.add("row-id-column-shadow");
    } else {
      let parentDOM = document.getElementById(this.props.store.gridId);
      parentDOM
        .getElementsByClassName("ag-pinned-left-cols-container")[0]
        .classList.remove("row-id-column-shadow");
      parentDOM
        .getElementsByClassName("ag-pinned-left-header")[0]
        .classList.remove("row-id-column-shadow");
      parentDOM
        .getElementsByClassName("ag-pinned-right-cols-container")[0]
        .classList.remove("row-id-column-shadow");
      parentDOM
        .getElementsByClassName("ag-pinned-right-header")[0]
        .classList.remove("row-id-column-shadow");
    }
    params.api.stopEditing(false);
  };

  handleScrollToBottomButtonClick = () => {
    this.props.store.jumpToLastRow();
  };

  onGridColumnsChanged = (e) => {
    this.gridApi = e.api;
    this.props.store.gridParams = e;
    this.props.store.gridApi = e.api;
    this.gridColumnApi = e.columnApi;
    this.props.store.columnDefs = e.columnApi.columnController.columnDefs;
    if (!this.props.store.isLazyLoadEnabled) {
      this.constructPinnedBottomData();
    }

    if (this.props.store.previousScrollLeft) {
      this.props.store.gridApi.gridPanel.setHorizontalScrollPosition(
        this.props.store.previousScrollLeft
      );
      this.props.store.previousScrollLeft = 0;
    }
  };
  handleCellKeyPress = (e) => {
    if (e.event.keyCode === 32) {
      const parentDOM = document.getElementById(this.props.store.gridId);
      const isRowSelected = e.node.isSelected();
      const isSubsheetRow = this.props.store.isSubsheet;
      const isGridEditing = this.gridApi.getEditingCells().length > 0;
      if (!isCellEditing || (isCellEditing && isSubsheetRow && !isGridEditing)) {
        this.props.store.addSelectedRecordsCount(isRowSelected ? 1 : -1);
        parentDOM.getElementsByClassName(e.node.data.uniqueId)[0].checked = isRowSelected ? true : false;
      } else if (isCellEditing && isSubsheetRow) {
        console.log("Grid is in editing mode. Ignoring addSelectedRecordsCount.");
      }
    }
  };
  handleCellValueChanged = async (e) => {
    if (!this.props.store.isFilling) {
      if (e.source === "paste") {
        let obj = {};
        obj.rowNode = e.node;
        obj.colDef = e.column.colDef;
        obj.newValue = e.oldValue;
        obj.oldValue = e.newValue;
        this.updateUndoStack([obj]);
        if (window.appStore.socket && window.appStore.socket?.connected && e.node && e.node?.data && e.node?.data?.row_id && e.node?.data?.row_id !== '+') {
          const columnName = e.column.colDef?.cellRendererParams?.columnRaw?.name ? e.column.colDef?.cellRendererParams?.columnRaw?.name : e.column.colDef?.cellRendererParams?.columnRaw?.alias_name ? e.column.colDef?.cellRendererParams?.columnRaw?.alias_name : '';
          if (this.updatedRowsData[e.node.data.row_id]) {
            this.updatedRowsData[e.node.data.row_id].push({'columnId': e.column.colDef.cellRendererParams?.columnId, 'columnName': columnName, 'columnPath': e.column.colDef.aliasPath});
          } else {
            this.updatedRowsData[e.node.data.row_id] = [{'columnId': e.column.colDef.cellRendererParams?.columnId, 'columnName': columnName, 'columnPath': e.column.colDef.aliasPath}];
          }
        }
      }
      this.props.store.handleCellValueChanged(e);
      this.props.store.redoStack = [];
      this.constructPinnedBottomData();
    }
  };
  addGrid = async (fetchDuplicatesDataForLazyLoad = true) => {
    if (this.agGridInstance) {
      this.props.store.resetCount();
      this.setState({
        rangeSelectionCalculations: {
          selectedCellsCount: null,
          sum: null,
          average: null,
          minimum: null,
          maximum: null,
        },
      });
      //todo: check why we should not use this api as gridapi at all places
      this.agGridInstance.gridOptions.api.destroy();
    }
    // await this.props.store.getView();

    var gridOptions = {
      onGridReady: (params) => this.onGridReady(params, fetchDuplicatesDataForLazyLoad),
      components: getGridComponents(this.props.store),
      columnDefs: this.props.store.columnDefs,
      defaultColDef: this.state.defaultColDef,
      context: this,
      immutableData: true,
      getRowNodeId: (data) => {
        if (!data.uniqueId) {
          console.error(data);
        }
        return data.uniqueId;
      },
      pinnedBottomRowData: this.state.pinnedBottomRowData,

      getRowStyle: this.state.getRowStyle,
      getRowHeight: this.state.getRowHeight,
      rowHeight: this.props.store.getRowHeight(), // infinite loading
      animateRows: true,
      enableCellChangeFlash: false,
      asyncTransactionWaitMillis: 2000,
      onAsyncTransactionsFlushed: (e) => {
        console.log(
          "========== onAsyncTransactionsFlushed: applied " +
            e.results 
        );
      },
      onColumnResized: this.columnResized,
      onCellValueChanged: this.handleCellValueChanged,
      onDragStopped: (e) => {
        if ($(e.target).find(".colHeaderContainer").length > 0) {
          this.props.store.handleViewColumnsOrderChange(e);
        }
      },
      onColumnPinned: this.props.store.handleViewColumnsOrderChange,
      rowSelection: "multiple",
      onCellKeyPress: this.handleCellKeyPress,
      rowDragManaged: true,
      onRowClicked: this.rowClicked,
      onCellClicked: (params) => {
        this.props.store.prevClickedCellRowId = params?.rowIndex;
        this.props.store.prevClickedCellColumnId =
          params?.column?.colDef?.cellRendererParams?.columnId;
        if (this.props.store.actionButtons.anchorEl != null) {
          this.props.store.isActionButtonsPopperOpen = false;
          this.props.store.actionButtons.anchorEl = null;
        }
      },
      onCellDoubleClicked: (params) => {
        if (
          Number(params.node.data.row_id) &&
          params?.colDef?.cellRendererParams?.columnTypeId != "6" &&
          params?.colDef?.cellRendererParams?.columnTypeId != "9" &&
          params?.colDef?.cellRendererParams?.columnTypeId != "comments_id" &&
          !this.props.store.isSubsheet &&
          !params?.colDef?.store?.containerStore?.permissions.canEdit(
            params?.colDef?.cellRendererParams?.columnId,
            params?.node?.data
          )[0]
        ) {
          const message = params?.colDef?.store?.containerStore?.permissions.canEdit(
            params?.colDef?.cellRendererParams?.columnId,
            params?.node?.data
          )[1];
          window.appStore.notificationStore.showNotification(
            message,
            "caution"
          );
        } else if (
          !Number(params.node.data.row_id) &&
          !this.props.store.isSubsheet &&
          params?.colDef?.store?.containerStore?.permissions.canAdd() &&
          !params?.colDef?.store?.containerStore?.permissions.canAddColumn(
            params?.colDef?.cellRendererParams?.columnId
          )[0]
        ) {
          const message = params?.colDef?.store?.containerStore?.permissions.canAddColumn(
            params?.colDef?.cellRendererParams?.columnId
          )[1];
          window.appStore.notificationStore.showNotification(
            message,
            "caution"
          );
        } else if (
          this.props.store.isSubsheet && this.props.store.parentListId
          ) {
            const parentListContainerStore = window.appStore.getCurrentListContainerStore(this.props.store.parentListId);
            const hasEditPermissions = parentListContainerStore?.permissions?.canEdit(this.props.store.parentColumnId, this.props.store.parentRow);
            if (hasEditPermissions && !hasEditPermissions[0] && params?.colDef?.cellRendererParams?.columnTypeId != "9") {
              window.appStore.notificationStore.showNotification(
                hasEditPermissions[1],
                "caution"
              );
            }          
        }
      },
      processCellForClipboard: this.processCellValueForClipboard,
      processDataFromClipboard: this.processDataFromClipboard,
      postProcessPopup: this.postProcessPopup,
      onPasteEnd: this.pasteEnded,
      onRowDataChanged: (e) => {
        try {
          this.props.store.onAgGridFilterChanged();
          this.constructPinnedBottomData();
          this.gridApi.redrawRows();
        } catch (err) {
          console.log(err);
        }
      },
      onGridColumnsChanged: this.onGridColumnsChanged,
      onCellFocused: (params) => {
        this.props.store.pasteColumnTypeId =
          params?.column?.colDef?.cellRendererParams?.columnTypeId;
        this.props.store.isReadOnlyCell =
          params?.column?.colDef?.cellRendererParams?.columnOptions?.is_read_only;
        this.shouldStartEditing(params);
      },
      onCellEditingStarted: (params) => {
        if (!isDirectDeletion) {
          isCellEditing = true;
          this.props.store.isGridCellEditing = isCellEditing;
          var obj = {};
          if (
            (Number(params.node.id) || params.node.id.includes("unique_")) &&
            params.column?.colDef?.cellRendererParams?.columnTypeId !== "6"
          ) {
            obj.rowNode = params.node;
            obj.colDef = params.column.colDef;
            obj.newValue = params.value;
            obj.oldValue = "";
            this.updateUndoStack([obj]);
          }
        } else {
          isDirectDeletion = false;
        }
      },
      onCellEditingStopped: (params) => {
        if (isCellEditing) {
          isCellEditing = false;
          this.props.store.isGridCellEditing = isCellEditing;
          if (
            this.props.store.undoStack.length &&
            params.column?.colDef?.cellRendererParams?.columnTypeId !== "6"
          ) {
            if (params?.oldValue !== params?.newValue) {
              this.props.store.undoStack[
                this.props.store.undoStack.length - 1
              ][0].oldValue = params.value;
            } else {
              this.props.store.undoStack.pop();
            }
          }
          if (
            this.props.store.nodesToRefresh.length > 0 &&
            this.gridApi.getEditingCells().length == 0
          ) {
            this.gridApi.redrawRows({
              rowNodes: this.props.store.nodesToRefresh,
            });
            let focusedCell = this.gridApi.getFocusedCell();
            if (focusedCell) {
              this.gridApi.setFocusedCell(
                focusedCell.rowIndex,
                focusedCell.column?.colId
              );
            }
            this.props.store.nodesToRefresh = [];
          }
        // this.constructPinnedBottomData();
        }
      },
      fillOperation: (params) => {
        if (
          params.context?.props?.view?.type == "table" &&
          params.context?.props?.view?.list_id &&
          params.context?.props?.view?.options?.main_list_id &&
          params.context?.props?.view?.list_id !=
            params.context?.props?.view?.options?.main_list_id
        ) {
          window.appStore.notificationStore.showNotification(
            "These are non editable cells.",
            "error"
          );
          return;
        }
        if (params.direction === "down" || params.direction === "right") {
          fillOperationInitialValues.push(params.currentCellValue);
          fillOperationDirection = "original";
        } else if (params.direction === "up" || params.direction === "left") {
          fillOperationInitialValues = [params.currentCellValue].concat(
            fillOperationInitialValues
          );
          fillOperationDirection = "reverse";
        }
        this.props.store.isFilling = true;
        return params.initialValues[0];
      },
      onFillEnd: (params) => {
        if (
          this.props?.view?.type == "table" &&
          this.props?.view?.list_id &&
          this.props?.view?.options?.main_list_id &&
          this.props?.view?.list_id != this.props?.view?.options?.main_list_id
        ) {
          return;
        }        
        this.handleFillCells(params);
      },
      enterMovesDownAfterEdit: false,
      onBodyScroll: this.onBodyScroll,
      postSort: this.postSort,
      onFilterChanged: this.onFilterChanged,
      getMainMenuItems: this.getMainMenuItems,
      getContextMenuItems: this.getContextMenuItems,
      suppressRowClickSelection: true,
      suppressMenuHide: true,
      suppressClipboardPaste: false,
      suppressMoveWhenRowDragging: true,
      suppressAggFuncInHeader: true,
      enableRangeSelection: true,
      enableFillHandle: true,
      enableMultiRowDragging: true,
      groupSelectsChildren: true,
      icons: this.state.icons,
      suppressScrollOnNewData: true,
      onRangeSelectionChanged: this.onRangeSelectionChanged.bind(this),
      groupUseEntireRow: true,
      groupRowInnerRenderer: this.state.groupRowInnerRenderer,
      groupRowRendererParams: {
        suppressCount: true,
      },
      tooltipShowDelay: this.state.tooltipShowDelay,
      rowModelType: this.props.store.shouldLoadAllRows
        ? "clientSide"
        : "infinite",
      cacheOverflowSize: 5,
      cacheBlockSize: 1000, // rows fetched every time
      maxConcurrentDatasourceRequests: 5,
      infiniteInitialRowCount: this.props.isSubsheet ? 1 : 15,
      // maxBlocksInCache: 5,
      navigateToNextCell: this.navigateToNextCell,
      tabToNextCell: this.tabToNextCell,
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Loading... </span>',
      ...(this.props.store.allRowsData.length > 0 && {
        rowData: this.props.store.allRowsData,
      }),
      ...(this.props.store.currentFilterModel && {
        filterModel: this.props.store.currentFilterModel,
      }),
      isRowSelectable : (rowNode) => {
        return rowNode?.data?.row_id == "+" ? false : true;
      }
    };
    var eGridDiv = document.querySelector("#" + this.props.store.gridId);

    this.agGridInstance = new window.agGrid.Grid(eGridDiv, gridOptions);

    this.setPreviousFilters(gridOptions.api);
    gridOptions.api.setSortModel(this.props.store.sorting);

    // reaction(
    //   () => this.props.store.view?.options.columns,
    //   (value, previousValue, reaction) => {
    //     this.props.store.handleViewChange();
    //   }
    // );
  };

  navigateToNextCell = (params) => {
    const suggestedNextCell = params?.nextCellPosition;
    const nextRowIndex = suggestedNextCell?.rowIndex ?? "";
    const nextColumnId = suggestedNextCell?.column?.colId ?? "";
    var renderedRowCount =
      this.gridApi?.rowModel?.rowsToDisplay?.[
        this.gridApi?.rowModel?.rowsToDisplay?.length - 1
      ]?.id === "+"
        ? this.gridApi.getModel().getRowCount() - 1
        : this.gridApi.getModel().getRowCount();
    switch (params.key) {
      case KEY_UP:
        if (nextRowIndex < 0) return null;
        else return suggestedNextCell;
      case KEY_DOWN:
        if (!nextRowIndex || nextRowIndex >= renderedRowCount) return null;
        else return suggestedNextCell;
      case KEY_LEFT:
        if (nextColumnId === "Id") return null;
        else return suggestedNextCell;
      case KEY_RIGHT:
        if (nextColumnId === "+") return null;
        else return suggestedNextCell;
      default:
        throw "navigation error";
    }
  };

  tabToNextCell = (params) => {
    const suggestedNextCell = params?.nextCellPosition;

    var nextRowIndex = suggestedNextCell.rowIndex;
    var nextColumn = suggestedNextCell?.column ?? {};

    const renderedRowCount = this.gridApi.getModel().getRowCount() - 1;

    if (nextColumn?.colId === "+") {
      nextRowIndex = nextRowIndex + 1;
      nextColumn = this?.gridApi?.columnController?.displayedCenterColumns?.[0];

      if (nextRowIndex < 0) nextRowIndex = 0;
      if (nextRowIndex >= renderedRowCount) nextRowIndex = renderedRowCount - 1;
    }

    var result = {
      rowIndex: nextRowIndex,
      column: nextColumn,
      floating: suggestedNextCell.floating,
    };

    return result;
  };

  redrawGridForGrouping = async (previousShouldLoadAllRows) => {
    if (!previousShouldLoadAllRows && this.props.store.shouldLoadAllRows) {
      this.addGrid(false);
      this.props.store.gridApi.showLoadingOverlay();
      return;
    }
    this.props.store.gridApi.showLoadingOverlay();

    await sleep(1);
    this.props.store.gridApi.setColumnDefs([]);
    this.props.store.gridApi.setColumnDefs(this.props.store.columnDefs);
    this.props.store.setAllRowsData({ api: this.props.store.gridApi });
    this.setPreviousFilters(this.props.store.gridApi);
  };

  setPreviousFilters(newGridApi) {
    this.props.store.currentFilterModel &&
      newGridApi.setFilterModel(this.props.store.currentFilterModel);
    this.props.store.quickSearchText &&
      newGridApi.setQuickFilter(this.props.store.quickSearchText);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleEnterKeyOnNewRow);
    window.removeEventListener("online", this.updateNetworkStatus);
    window.removeEventListener("offline", this.updateNetworkStatus);
    document
      .querySelector("#root")
      .removeEventListener("mousedown", this.handleClickOutsideGrid);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.columns !== nextProps.columns) {
      //for subsheet
      this.updateColumnsForSubsheet(nextProps);
    }
  }

  updateColumnsForSubsheet(nextProps) {
    const store = this.props.store;

    store.setColumns(nextProps.columns);
    store.formatColumns(nextProps.columns);
    store.gridApi?.setColumnDefs([]);
    store.gridApi?.setColumnDefs(store.columnDefs);
  }

  selectAggregation = (colDataField, aggregationType) => {
    this.props.store.updateColumnsWithAggregation(
      colDataField,
      aggregationType
    );
    this.constructPinnedBottomData();
  };

  render() {
    return (
      <div
        ref={this.agGridDomRef}
        className="ag-theme-material-custom"
        style={{
          // height: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          // window.innerHeight -
          // DIMENSIONS.header1 -
          // DIMENSIONS.header2 -
          // DIMENSIONS.toolbar -
          // DIMENSIONS.status_bar -
          // DIMENSIONS.browser_status,
          width: "100%",
          height: "100%",
          // marginBottom: 30,
        }}
      >
        <div
          id={this.props.store.gridId}
          style={{
            flex: 1,
            // height: this.props.isSubsheet ? "94%" : "100%",
            width: "100%",
          }}
        >
          <TriggerColumnPopper
            store={this.props.store}
            ref={this.actionButtonsPopperRef}
          />
          <ErrorTooltip store={this.props.store} />
          <OverflowTooltip store={this.props.store} />
        </div>
        {
          <Grow in={this.props.store.isScrollToLastButtonVisible}>
            <Fab
              variant="extended"
              style={{
                position: "absolute",
                bottom: 110,
                right: 30,
                zIndex: 10,
              }}
              size="medium"
              onClick={this.handleScrollToBottomButtonClick}
            >
              <NavigationIcon style={{ transform: "rotate(-180deg)" }} />
              Scroll To Bottom
            </Fab>
          </Grow>
        }
        {this.props.isSubsheet && this.props.store.currentApiCallsCount > 0 && (
          <div style={{ color: "green", position: "absolute", bottom: "60px" }}>
            <CircularProgress size={10} color={"inherit"} /> Saving...
          </div>
        )}
        {Object.keys(this.state.gridApi).length && (
          <Pages
            gridApi={this.state.gridApi}
            store={this.props.store}
            rangeSelectionCalculations={this.state.rangeSelectionCalculations}
            selectedSheet={this.state.selectedSheet}
          />
        )}
        <div style={{ height: DIMENSIONS.browser_status }} />
        {this.state.networkDisconnected && (
          <Snackbar
            key="networkSnackbar"
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            open={true}
            message="Network Error. Please check your internet connection."
          />
        )}
        <AddColumnPopup
          store={this.props.store.addColumnStore}
          onColumnConfigChange={this.props.onColumnConfigChange}
        />
      </div>
    );
  }
}

export default observer(Table);
